import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=71c51e49&scoped=true&"
var script = {}
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=71c51e49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c51e49",
  null
  
)

export default component.exports